import HeaderComponent from './component'

const Header: React.FC = (): React.ReactElement => {
    return <HeaderComponent />
}
export default Header
